// extracted by mini-css-extract-plugin
export var copyableItem = "_4h-0";
export var underlined = "_4h-1";